import React from 'react';
import { Skeleton } from '@shared/components/Skeleton';
import { Box, Flex, SpacingStack } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const INPUT_BORDER_RADIUS = 2;

export const CreateWeddingFormSkeleton: React.FC = () => {
  return (
    <SpacingStack
      width="100%"
      spacing={8}
    >
      <SpacingStack
        spacing={5}
        width="100%"
        alignItems="center"
      >
        <Skeleton
          height={pxToRem(62)}
          width="70%"
          borderRadius={INPUT_BORDER_RADIUS}
        />
        <Skeleton
          height={pxToRem(16)}
          width="50%"
          borderRadius={INPUT_BORDER_RADIUS}
        />
      </SpacingStack>

      <SpacingStack
        width="100%"
        spacing={6}
      >
        <SpacingStack spacing={2}>
          <Box height={pxToRem(14)} />
          <Skeleton
            height={pxToRem(50)}
            width="100%"
            borderRadius={INPUT_BORDER_RADIUS}
          />
        </SpacingStack>

        <SpacingStack spacing={2}>
          <Box height={pxToRem(14)} />
          <Skeleton
            height={pxToRem(50)}
            width="100%"
            borderRadius={INPUT_BORDER_RADIUS}
          />
        </SpacingStack>

        <SpacingStack spacing={5}>
          <SpacingStack spacing={2}>
            <Box height={pxToRem(14)} />
            <Skeleton
              height={pxToRem(50)}
              width="100%"
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </SpacingStack>
          <Flex
            gap={3}
            flexDirection="row"
            alignItems="center"
          >
            <Skeleton
              height={pxToRem(20)}
              width={pxToRem(20)}
              borderRadius={INPUT_BORDER_RADIUS}
            />
            <Skeleton
              height={pxToRem(14)}
              width={pxToRem(180)}
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </Flex>
        </SpacingStack>

        <SpacingStack spacing={5}>
          <SpacingStack spacing={2}>
            <Box height={pxToRem(14)} />
            <Skeleton
              height={pxToRem(50)}
              width="100%"
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </SpacingStack>
          <Flex
            gap={3}
            flexDirection="row"
            alignItems="center"
          >
            <Skeleton
              height={pxToRem(20)}
              width={pxToRem(20)}
              borderRadius={INPUT_BORDER_RADIUS}
            />
            <Skeleton
              height={pxToRem(14)}
              width={pxToRem(200)}
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </Flex>
        </SpacingStack>
      </SpacingStack>

      <SpacingStack
        width="100%"
        spacing={6}
        alignItems="center"
      >
        <Skeleton
          height={9}
          width="100%"
          borderRadius={INPUT_BORDER_RADIUS}
        />
        <Skeleton
          height={pxToRem(16)}
          width="80%"
          borderRadius={INPUT_BORDER_RADIUS}
        />
      </SpacingStack>
    </SpacingStack>
  );
};

export default CreateWeddingFormSkeleton;
